<div id="main-mobile-header" class="mobile-header">
  <div
    id="main-mobile-header-textback-menu"
    class="mobile-header-textback showmenu"
    *ngIf="showHamburger"
  >
    <app-icon
      id="mobile-header-menu-icon"
      [name]="'menu'"
      [size]="'1.8em'"
      (iconClicked)="onMenuIconClick()"
    >
    </app-icon>
    <app-text
      id="mobile-header-text"
      [textStyleType]="'headline2'"
      class="single-text"
      *ngIf="!showTitleSubTitleWithHamberger"
    >
      {{ titleTextKey | translate }}
    </app-text>
    <app-title-subtitle
      id="mobile-header-subtitle-text"
      [title]="overlineText"
      [subtitle]="titleTextKey | translate"
      [titleFontStyle]="'subhead2'"
      [subtitlePadding]="'0.8em'"
      [subtitleFontStyle]="'headline2'"
      [alignment]="'left'"
      class="double-text"
      *ngIf="showTitleSubTitleWithHamberger"
    >
    </app-title-subtitle>
  </div>
  <div
    id="main-mobile-header-textback-back"
    class="mobile-header-textback showback"
    *ngIf="!showHamburger"
  >
    <app-icon
      id="mobile-header-back-icon"
      *ngIf="!showCloseIconInReplaceOfBackIcon && showBackIcon"
      [name]="'arrow_back'"
      [size]="'1.8em'"
      (iconClicked)="onBackIconClick()"
    >
    </app-icon>
    <app-icon
      id="mobile-header-close-back-icon"
      *ngIf="showCloseIconInReplaceOfBackIcon"
      [name]="'close'"
      [size]="'1.8em'"
      (iconClicked)="onCloseBackIconClick()"
    >
    </app-icon>
    <app-title-subtitle
      id="mobile-header-tisub-text"
      [title]="overlineText"
      [subtitle]="titleTextKey | translate"
      [titleFontStyle]="'subhead2'"
      [subtitlePadding]="'0.8em'"
      [subtitleFontStyle]="'headline2'"
      [alignment]="'left'"
      class="double-text"
    >
    </app-title-subtitle>
  </div>
  <div id="main-mobile-header-close" class="mobile-header-cross" *ngIf="!showHamburger">
    <app-icon
      id="mobile-header-close-icon"
      *ngIf="showCloseIcon"
      [name]="'close'"
      [size]="'1.8em'"
      (iconClicked)="onCloseIconClick()"
    >
    </app-icon>
  </div>
</div>
